// extracted by mini-css-extract-plugin
module.exports = {"originalRatio":"VideojsPlayer_originalRatio__3xzAV","displayRatio":"VideojsPlayer_displayRatio__13cdX","player":"VideojsPlayer_player__3N88V"};